module.exports = __webpack_public_path__ + "images/icon-managers.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-managers.png
// module id = 4EXw
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13